var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-connector-wrapper"},[_c('span',{staticClass:"connector"},[_vm._v(" "+_vm._s(_vm._f("uppercase")((_vm.filtersMatch === _vm.$enums.AppFilter.FilterMathType.ALL ? _vm.$t('$General.And') : _vm.$t('$General.Or'))))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }